import { default as CharitableDonations } from './charitableDonations';
export default CharitableDonations;
